"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformEntityApiResponse = void 0;
const api_response_1 = require("./api.response");
class TransformEntityApiResponse extends api_response_1.TransformApiResponse {
    response;
    constructor(response) {
        super();
        this.response = response;
    }
    handle({ response = this.response, attributes, relations, schema, }) {
        // Attributes
        const dataAttributes = this.transformAttributes({
            attributes: response.data.attributes,
            transform: attributes,
        });
        // Relations
        const dataRelations = this.transformApiEntityRelations({
            relationships: response.data.relationships,
            included: response.included,
            transform: relations,
        });
        const data = {
            id: response.data.id,
            ...dataAttributes,
            ...dataRelations,
        };
        try {
            return (schema ? schema.parse(data) : data);
        }
        catch (err) {
            console.error('TransformEntityApiResponse::', {
                response,
                transform: data,
            });
            throw err;
        }
    }
}
exports.TransformEntityApiResponse = TransformEntityApiResponse;
